import { render, staticRenderFns } from "./JMonth.vue?vue&type=template&id=e52a4c96"
import script from "./JMonth.vue?vue&type=script&lang=js"
export * from "./JMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports